import API from 'services/api';

import { ICalculationVisitDetails } from '../models';

export const getCalculationGuestDetails = (
  calculationId: string,
  visitId?: string,
  isEnabled = true,
): Promise<ICalculationVisitDetails> | undefined => {
  if (!isEnabled || visitId === undefined) {
    return undefined;
  }

  return API.get(`/api/accommodation/calculations/${calculationId}/guests/${visitId}`).then(
    response => response?.data,
  );
};
